firebird.factory('localStreamManagerService', [
    '$rootScope',
    '$window',
    '$q',
    '$interval',
    'storageService',
    'logService',
    'helperService',
    'videoFilterService',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $window,
        $q,
        $interval,
        storageService,
        logService,
        helperService,
        videoFilterService,
        executionEnvironmentEnum
    ) {
        //Main Idea: only one video track exists at one time, and this service enforces that...
        //  * When a meeting starts, vertoService creates its own local RTC stream.
        //    We keep a reference to that RTC stream's video track in this service.
        //
        //  * After that initial join, if we need a new local video track at all,
        //    this service handles the starting/stopping of new video tracks.
        //
        //Current locations that use a local video stream:
        //  1. vertoService (for the main Stream to FS)
        //  2. peerConnectionService (for One-On-One PIP Mode)
        //  3. meetingActiveCtrl (for Single-Share Stream)

        const logger = logService.createLoggerWithSource('localStreamManagerService');

        var service = {
            //Properties
            idealVideoConstraints: {
                width: {
                    min: 320,
                    max: 1280,
                    ideal: 1280
                },
                height: {
                    min: 180,
                    max: 720,
                    ideal: 720
                },
                frameRate: {
                    min: 5,
                    max: 15,
                    ideal: 15
                },
                aspectRatio: 1.777777778, //16:9
                //Advanced is an attempt to enfource a combination of constraints
                //For example:
                //  Option 1: Must have 1280x720 AND frameRate 15
                //  Option 2: Must have 640x360 with any frameRate between 5-15 (due to min/max/ideal settings above)
                //If Option 1 cannot be satisafied, it will attempt Option 2
                //If neither options can be satisfied, it will attempt range of constraints that satisfy the min/max/ideal settings above
                //
                //This is needed because some webcams at 1280x720 will not work with frameRate under 15
                advanced: [
                    { width: 1280, height: 720, frameRate: 15 },
                    { width: 640, height: 360 }
                ]
            },
            dynamicConstraints: {
                1: {
                    videoConstraints: {
                        width: {
                            min: 640,
                            max: 1280,
                            ideal: 1280
                        },
                        height: {
                            min: 360,
                            max: 720,
                            ideal: 720
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778,
                        advanced: [
                            { width: 1280, height: 720, frameRate: 15 },
                            { width: 640, height: 360 }
                        ]
                    },
                    bandwidth: 1024000
                },
                2: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778
                    },
                    bandwidth: 512000
                },
                3: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                4: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                5: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                6: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                7: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                8: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                9: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                10: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                11: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                12: {
                    videoConstraints: {
                        width: {
                            min: 320,
                            max: 640,
                            ideal: 640
                        },
                        height: {
                            min: 180,
                            max: 360,
                            ideal: 360
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 512000
                },
                content: {
                    videoConstraints: {
                        width: {
                            min: 160,
                            max: 320,
                            ideal: 320
                        },
                        height: {
                            min: 90,
                            max: 180,
                            ideal: 180
                        },
                        frameRate: {
                            min: 5,
                            max: 15,
                            ideal: 15
                        },
                        aspectRatio: 1.777777778 //16:9
                    },
                    bandwidth: 256000
                }
            },
            //TODO: Rename 'currentLocalStream' to 'currentLocalVideoOnlyStream' (or something similar)
            currentLocalStream: null, //Should only handle video tracks
            currentLocalVideoTrack: null,
            isRetrievingUserMedia: false,
            currentLocalAudioTrack: null, //We don't need to keep reference of audio-only stream... just the track
            currentDynamicConstraint: null,
            inactiveLocalVideoStream: null,
            inactiveLocalVideoTrack: null,
            // VDI-only
            currentWebcamStream: null,

            //This will represent a clone of the active audio stream used in the conference
            //Used for tracking audio levels locally
            clonedAudioStream: null,
            setClonedAudioStream: setClonedAudioStream,
            stopClonedAudioStream: stopClonedAudioStream,
            createMediaStream: createMediaStream,

            //Video-Related Functions
            getLocalStream: getLocalStream,
            initLocalVideoTrack: initLocalVideoTrack,
            stopLocalVideoTrack: stopLocalVideoTrack,
            isLocalVideoTrackActive: isLocalVideoTrackActive,
            replaceLocalVideoTrack: replaceLocalVideoTrack,
            updateLocalVideoTrackReference: updateLocalVideoTrackReference,
            adjustConstraints: adjustConstraints,
            getAdjustedBitrate: getAdjustedBitrate,
            getIdealVideoConstraints: getIdealVideoConstraints,
            initInactiveLocalVideoStreamFromClone: initInactiveLocalVideoStreamFromClone,

            //Audio-Related Functions
            getLocalAudioStream: getLocalAudioStream,
            initLocalAudioTrack: initLocalAudioTrack,
            stopLocalAudioTrack: stopLocalAudioTrack,
            isLocalAudioTrackActive: isLocalAudioTrackActive,
            replaceLocalAudioTrack: replaceLocalAudioTrack,

            //General Functions
            onStateChangeStart: onStateChangeStart,
            shouldUseDeprecatedSpecForStreams: shouldUseDeprecatedSpecForStreams,
            setAspectRatio: setAspectRatio,
            addEndedEventListener: addEndedEventListener,
            clearEndedEventListener: clearEndedEventListener,

            overwriteLocalStream: overwriteLocalStream,
            setCurrentWebcamStreamForVDI: setCurrentWebcamStreamForVDI,
            getCurrentWebcamStreamForVDI: getCurrentWebcamStreamForVDI,
            getCurrentLocalAudioTrack: getCurrentLocalAudioTrack
        };

        $rootScope.$on('$stateChangeStart', service.onStateChangeStart);

        return service;

        ////////////////////////

        function setClonedAudioStream(stream) {
            try {
                service.stopClonedAudioStream();

                var hasStream = !!stream;
                logger.log(
                    'localStreamManagerService - setting cloned audio stream: has stream = ' +
                        hasStream +
                        ', has audio track = ' +
                        hasStream
                        ? stream.getAudioTracks().length > 0
                        : false
                );

                if (!hasStream || stream.getAudioTracks().length === 0) {
                    return;
                }

                if (helperService.getVDIRef().preventAudioStreamClone) {
                    service.clonedAudioStream = stream;
                    service.clonedAudioStream.getAudioTracks()[0].onended = function () {
                        $rootScope.$broadcast('cloned-audio-track-ended');
                    };
                    return;
                }

                service.clonedAudioStream = service.createMediaStream();
                var clonedAudioTrack = stream.getAudioTracks()[0].clone();
                service.clonedAudioStream.addTrack(clonedAudioTrack);
                clonedAudioTrack.enabled = true;
                $rootScope.$broadcast('cloned-audio-stream-ready');

                clonedAudioTrack.addEventListener('ended', function () {
                    $rootScope.$broadcast('cloned-audio-track-ended');
                });
            } catch (e) {
                logger.error('setClonedAudioStream', 'error cloning audio stream', e);
            }
        }

        function createMediaStream() {
            return new MediaStream();
        }

        function stopClonedAudioStream() {
            if (service.clonedAudioStream) {
                logger.log('localStreamManagerService - stopping cloned audio stream');

                if (service.clonedAudioStream.getTracks) {
                    try {
                        service.clonedAudioStream.getTracks().forEach(function (track) {
                            track.stop();
                        });
                    } catch (e) {
                        logger.error('stopClonedAudioStream', 'error stopping cloned audio stream tracks', e);
                    }
                }

                service.clonedAudioStream = null;
            }
        }

        //TODO: This should be renamed to 'getLocalVideoStream'
        function getLocalStream(videoDeviceId) {
            var deferred = $q.defer();

            if (service.currentLocalStream && service.isLocalVideoTrackActive()) {
                deferred.resolve(service.currentLocalStream);
                return deferred.promise;
            }

            //Prevents multiple calls to getUserMedia
            if (service.isRetrievingUserMedia) {
                var waitingForUserMediaInterval = $interval(function () {
                    if (!service.isRetrievingUserMedia) {
                        $interval.cancel(waitingForUserMediaInterval);
                        deferred.resolve(service.currentLocalStream);
                    }
                }, 500);

                return deferred.promise;
            }

            service.isRetrievingUserMedia = true;

            if (videoFilterService.getIsVideoFiltersAvailable()) {
                var getVideoFilterMedia = function () {
                    var videoFilterConstraints = service.getIdealVideoConstraints('video-filter');
                    if (videoDeviceId) {
                        videoFilterConstraints.deviceId = { exact: videoDeviceId };
                    }
                    var videoFilterMedia = {
                        audio: false,
                        video: videoFilterConstraints
                    };

                    return videoFilterMedia;
                };
                var startVideoFilterCallback = function (identifier, error) {
                    if (error) {
                        service.isRetrievingUserMedia = false;
                        deferred.reject(error);
                    } else {
                        service.isRetrievingUserMedia = false;
                        deferred.resolve(videoFilterStream);
                    }
                };

                var videoFilterStream = videoFilterService.startVideoFilterStream(
                    getVideoFilterMedia,
                    undefined,
                    undefined,
                    startVideoFilterCallback
                );
                if (videoFilterStream) {
                    service.currentLocalStream = videoFilterStream;
                    return deferred.promise;
                }
            }

            var videoConstraints = service.getIdealVideoConstraints();
            if (videoDeviceId) {
                videoConstraints.deviceId = { exact: videoDeviceId };
            }
            if ($window.navigator.mediaDevices && $window.navigator.mediaDevices.getUserMedia) {
                $window.navigator.mediaDevices
                    .getUserMedia({
                        audio: false,
                        video: videoConstraints
                    })
                    .then(function (newStream) {
                        service.isRetrievingUserMedia = false;
                        service.currentLocalStream = newStream;
                        deferred.resolve(newStream);
                    })
                    .catch(function (err) {
                        service.isRetrievingUserMedia = false;
                        deferred.reject(err);
                        logger.error('getLocalStream', 'getUserMedia error', err);
                        $rootScope.$broadcast('send-msgflow-event', {
                            name: `device-error`,
                            data: {
                                reason: 'getLocalStream',
                                constraints: {
                                    audio: false,
                                    video: videoConstraints
                                },
                                error: err?.name
                            }
                        });
                    });
            } else {
                deferred.reject('getUserMedia does not exist');
            }

            return deferred.promise;
        }

        function initLocalVideoTrack(customVideoDeviceId) {
            videoFilterService.initVideoFilter();

            var deferred = $q.defer();
            var videoDeviceId = customVideoDeviceId || storageService.get('video-device');

            if (service.shouldUseDeprecatedSpecForStreams()) {
                if (service.currentLocalVideoTrack) {
                    service.currentLocalVideoTrack.enabled = true;
                }

                deferred.resolve();
                return deferred.promise;
            }

            if (service.isLocalVideoTrackActive()) {
                deferred.resolve();
            } else {
                service
                    .getLocalStream(videoDeviceId)
                    .then(function (newStream) {
                        var setDynamic = false;
                        service.addEndedEventListener(newStream.getVideoTracks()[0]);
                        service.updateLocalVideoTrackReference(newStream.getVideoTracks()[0]);
                        if (service.currentDynamicConstraint && service.isLocalVideoTrackActive()) {
                            setDynamic = true;
                            service.currentLocalVideoTrack.applyConstraints(service.currentDynamicConstraint);
                        }
                        deferred.resolve(setDynamic);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        }

        function stopLocalVideoTrack() {
            if (service.shouldUseDeprecatedSpecForStreams()) {
                if (service.currentLocalVideoTrack) {
                    service.currentLocalVideoTrack.enabled = false;
                }

                return;
            }

            videoFilterService.stopVideoFilterStream();

            if (service.isLocalVideoTrackActive()) {
                service.clearEndedEventListener(service.currentLocalVideoTrack);
                service.currentLocalVideoTrack.stop();
            }
        }

        function isLocalVideoTrackActive() {
            return service.currentLocalVideoTrack ? service.currentLocalVideoTrack.readyState === 'live' : false;
        }

        function overwriteLocalStream(newStream) {
            if (service.currentLocalStream && service.currentLocalStream.getVideoTracks) {
                var existing = service.currentLocalStream.getVideoTracks();
                if (existing && existing.length > 0) {
                    existing.forEach(function (track) {
                        if (track) {
                            try {
                                track.stop();
                            } catch (err) {}
                        }
                    });
                }
            }
            service.currentLocalStream = newStream;
        }

        function replaceLocalVideoTrack(newLocalVideoTrack) {
            logger.log('calling replaceLocalVideoTrack ... ');
            if (service.currentLocalStream && service.currentLocalStream.getVideoTracks) {
                var currentVideoTrackFromStream = service.currentLocalStream.getVideoTracks()[0];
                if (currentVideoTrackFromStream) {
                    if (currentVideoTrackFromStream.id === newLocalVideoTrack.id) {
                        return;
                    }

                    service.clearEndedEventListener(currentVideoTrackFromStream);
                    currentVideoTrackFromStream.stop();

                    service.currentLocalStream.removeTrack(currentVideoTrackFromStream);
                }

                service.addEndedEventListener(newLocalVideoTrack);
                service.currentLocalStream.addTrack(newLocalVideoTrack);

                service.updateLocalVideoTrackReference(newLocalVideoTrack);
            }
        }

        function updateLocalVideoTrackReference(newLocalVideoTrack) {
            service.currentLocalVideoTrack = newLocalVideoTrack;
        }

        function getLocalAudioStream(defaultAudioDevice) {
            var deferred = $q.defer();

            var getUserMedia = $window.getUserMedia || $window.navigator.getUserMedia;
            if (getUserMedia) {
                const constraints = {
                    audio: defaultAudioDevice ? { deviceId: { exact: defaultAudioDevice } } : true,
                    video: false
                };
                getUserMedia(
                    constraints,
                    function (newStream) {
                        deferred.resolve(newStream);
                    },
                    function (err) {
                        deferred.reject(err);
                        logger.error('getLocalAudioStream', 'getUserMedia error', err);
                        $rootScope.$broadcast('send-msgflow-event', {
                            name: `device-error`,
                            data: { reason: 'getLocalAudioStream', constraints, error: err?.name }
                        });
                    }
                );
            } else {
                deferred.reject('getUserMedia does not exist');
            }

            return deferred.promise;
        }

        function initLocalAudioTrack(customAudioDeviceId, forceNewStream) {
            var deferred = $q.defer();
            var audioDeviceId = customAudioDeviceId || storageService.get('audio-device');

            if (service.isLocalAudioTrackActive() && !forceNewStream) {
                deferred.resolve();
            } else {
                service
                    .getLocalAudioStream(audioDeviceId)
                    .then(function (newStream) {
                        service.addEndedEventListener(newStream.getAudioTracks()[0]);
                        service.currentLocalAudioTrack = newStream.getAudioTracks()[0];
                        deferred.resolve();
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        }

        function stopLocalAudioTrack() {
            if (service.isLocalAudioTrackActive()) {
                service.clearEndedEventListener(service.currentLocalAudioTrack);
                service.currentLocalAudioTrack.stop();
            }
        }

        function isLocalAudioTrackActive() {
            return service.currentLocalAudioTrack ? service.currentLocalAudioTrack.readyState === 'live' : false;
        }

        function replaceLocalAudioTrack(newLocalAudioTrack) {
            if (service.currentLocalAudioTrack && service.currentLocalAudioTrack.stop) {
                if (newLocalAudioTrack && newLocalAudioTrack.id === service.currentLocalAudioTrack.id) {
                    return;
                }

                service.clearEndedEventListener(service.currentLocalAudioTrack);
                service.currentLocalAudioTrack.stop();
            }

            service.addEndedEventListener(newLocalAudioTrack);
            service.currentLocalAudioTrack = newLocalAudioTrack;

            var audioTrackSettings = service.currentLocalAudioTrack.getSettings();
            if (
                audioTrackSettings &&
                audioTrackSettings.deviceId &&
                audioTrackSettings.deviceId !== storageService.get('audio-device')
            ) {
                logger.log(
                    'localStreamManagerService - updating storageService audio-device to:',
                    audioTrackSettings.deviceId
                );
                storageService.set('audio-device', audioTrackSettings.deviceId);
            }
        }

        function onStateChangeStart(event, toState, toParams, fromState, fromParams) {
            var fromMeetingActiveState = fromState && fromState.name && fromState.name.indexOf('meeting-active') > -1;
            var toMeetingActiveState = toState && toState.name && toState.name.indexOf('meeting-active') > -1;

            //Stops video tracks when leaving meeting-active view...
            //
            //When changing between tabs (Attendees, Chat, Notes), the state changes between
            //'meeting-active.attendees', 'meeting-active.chat', and 'meeting-active.notes'...
            //so we also need to make sure that to toState does not include 'meeting-active'
            if (fromMeetingActiveState && !toMeetingActiveState) {
                service.stopLocalVideoTrack();
            }
        }

        function shouldUseDeprecatedSpecForStreams() {
            if (helperService.isMobile() && !helperService.isAndroid()) {
                return true;
            }

            if (helperService.isElectron()) {
                return !helperService.isElectronVersionSupported();
            }

            if (helperService.isChrome() || helperService.isAndroid()) {
                return !helperService.isBrowserVersionSupported();
            }

            return false;
        }

        function setAspectRatio(newAspectRatio) {
            if (service.currentLocalVideoTrack && service.currentLocalVideoTrack.applyConstraints) {
                var targetConstraints = service.currentLocalVideoTrack.getConstraints();

                if (targetConstraints) {
                    targetConstraints.aspectRatio = newAspectRatio;
                } else {
                    targetConstraints = {
                        aspectRatio: newAspectRatio
                    };
                }
                service.currentLocalVideoTrack.applyConstraints(targetConstraints);
            }
        }

        function adjustConstraints(isContentSharing, numberOfCams) {
            if (typeof isContentSharing === 'undefined' || isNaN(numberOfCams)) {
                logger.log('adjustConstraints called with invalid parameters');
                service.currentDynamicConstraint = null;
                return;
            }

            if (service.currentLocalVideoTrack && service.currentLocalVideoTrack.applyConstraints) {
                if (isContentSharing) {
                    service.currentDynamicConstraint = service.dynamicConstraints.content.videoConstraints;
                } else {
                    service.currentDynamicConstraint = service.dynamicConstraints[numberOfCams].videoConstraints;
                }
            }

            if (service.isLocalVideoTrackActive() && service.currentDynamicConstraint) {
                logger.log('adjustConstraints found active local track');
                service.currentLocalVideoTrack.applyConstraints(service.currentDynamicConstraint);
            }
        }

        function getAdjustedBitrate(isContentSharing, numberOfCams) {
            if (typeof isContentSharing === 'undefined' || isNaN(numberOfCams)) {
                logger.log('getAdjustedBitrate called with invalid parameters');
                return service.dynamicConstraints[1].bandwidth;
            }

            if (service.currentLocalVideoTrack && service.currentLocalVideoTrack.applyConstraints) {
                if (isContentSharing) {
                    return service.dynamicConstraints.content.bandwidth;
                } else {
                    if (service.dynamicConstraints[numberOfCams]) {
                        return service.dynamicConstraints[numberOfCams].bandwidth;
                    }
                }
            }

            return service.dynamicConstraints[1].bandwidth;
        }

        function getIdealVideoConstraints(videoType) {
            //Create copy ofidealVideoConstraints so we can modify without changing original obj
            var videoConstraints = Object.assign({}, service.idealVideoConstraints);
            if (videoType === 'video-filter') {
                videoConstraints.width = videoConstraints.width.ideal;
                videoConstraints.height = videoConstraints.height.ideal;
                videoConstraints.frameRate = videoConstraints.frameRate.ideal;
            }
            return videoConstraints;
        }

        function initInactiveLocalVideoStreamFromClone(streamToClone) {
            if (!service.inactiveLocalVideoStream && streamToClone && streamToClone.clone) {
                service.inactiveLocalVideoStream = streamToClone.clone();
                service.inactiveLocalVideoTrack = service.inactiveLocalVideoStream.getVideoTracks()[0];
                service.inactiveLocalVideoTrack.enabled = false;
                service.inactiveLocalVideoTrack.stop();
                service.inactiveLocalVideoTrack.isClone = true;
            }
        }

        function addEndedEventListener(track) {
            if (track && track.addEventListener && !track.hackListener) {
                track.hackListener = function () {
                    logger.log('track ' + this.label + '(' + this.kind + ') ended unexpectedly');
                    $rootScope.$broadcast('send-msgflow-event', {
                        name: `track-ended:${track.kind}`,
                        data: { reason: 'stream manager' }
                    });
                    if (videoFilterService.getIsSfuEnabled()) {
                        // handler of this will dispatch active-track-ended if needed.
                        $rootScope.$broadcast('active-sfu-track-ended', { track });
                    } else {
                        $rootScope.$broadcast('active-track-ended', track);
                    }
                };
                if (helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.VMware) {
                    track.onended = track.hackListener;
                } else {
                    track.addEventListener('ended', track.hackListener);
                }
            }
        }

        function clearEndedEventListener(track) {
            if (track && track.removeEventListener && track.hackListener) {
                track.removeEventListener('ended', track.hackListener);
                track.hackListener = null;
            }
        }

        // VDI only - must be called if hasVDI
        function setCurrentWebcamStreamForVDI(stream) {
            service.currentWebcamStream = stream;
        }

        // VDI only - must be called if hasVDI
        function getCurrentWebcamStreamForVDI() {
            return service.currentWebcamStream;
        }

        function getCurrentLocalAudioTrack() {
            return service.currentLocalAudioTrack;
        }
    }
]);
